export default "__VITE_ASSET__dVFz0Ssb__"